import * as React from 'react';

/** Controlled tooltip state that also opens on a touch or pen tap, since touch has no hover. */
export function useOpenOnTap() {
  const [open, setOpen] = React.useState(false);
  const openedByTap = React.useRef(false);

  const triggerProps = {
    onPointerDown: (event: React.PointerEvent) => {
      if (event.pointerType === 'mouse') return;
      openedByTap.current = true;
      setOpen(true);
    },
    onClick: (event: React.MouseEvent) => {
      // Radix closes a tooltip on trigger click, which would undo the tap that just opened it.
      if (openedByTap.current) event.preventDefault();
      openedByTap.current = false;
    },
  };

  return { open, onOpenChange: setOpen, triggerProps };
}
